import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'

export default store => ({
  path: `${Routes.CONFIRM_USER_INFO}`,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([
      import('./containers/ConfirmUserInfoContainer'),
      import('./reducers')
    ])

    injectReducer(store, { key: 'confirmUserInfo', reducer: reducer.default })

    cb(null, module.default)
  }
})
